import React from 'react';
import { FormType } from '@graphql/generated';
import { Box } from '@withjoy/joykit';
import { useTranslation } from '@shared/core/i18n/useTranslation';
import { StepHeader } from '../components/StepHeader';
import { STEP_MINIMUM_HEIGHT } from '../consts';

export const DisabledStep = ({ formType }: { formType: FormType }) => {
  const { tq } = useTranslation('eventFormDisplay');
  const formTypeLabel = formType === FormType.REGISTRATION ? tq`Registration` : tq`RSVP`;

  return (
    <Box minHeight={STEP_MINIMUM_HEIGHT}>
      <StepHeader
        heading={tq`No longer Accepting Responses`}
        subheading={tq`${formTypeLabel} is closed. Please contact the host if you have any questions.`}
      />
    </Box>
  );
};
